import { takeLatest, put, call } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  COMPLETED_COURSES_GET,
  DASHBOARD_INFO_GET,
  EMPTY_COURSES_GET,
  LAST_COURSES_GET,
} from '../actions/dashboard';
import dashboard from '../../api/dashboard';
import courselist from '../../api/courselist';

function* dashboardInfoGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      dashboard.dashboardInfo
    );
    yield put({ type: DASHBOARD_INFO_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > dashboard > dashboardInfoGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* dashboardInfoGetWatch() {
  yield takeLatest(DASHBOARD_INFO_GET._REQUEST, dashboardInfoGet);
}

function* emptyCoursesGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data: response, pager } = {} } = yield call(
      courselist.getCoursesList,
      completeFilters
    );
    yield put({ type: EMPTY_COURSES_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > dashboard > emptyCoursesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* emptyCoursesGetWatch() {
  yield takeLatest(EMPTY_COURSES_GET._REQUEST, emptyCoursesGet);
}

function* lastCoursesGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data: response, pager } = {} } = yield call(
      courselist.getCoursesList,
      completeFilters
    );
    yield put({ type: LAST_COURSES_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > dashboard > lastCoursesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* lastCoursesGetWatch() {
  yield takeLatest(LAST_COURSES_GET._REQUEST, lastCoursesGet);
}

function* completedCoursesGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data: response, pager } = {} } = yield call(
      courselist.getCoursesList,
      completeFilters
    );
    yield put({ type: COMPLETED_COURSES_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > dashboard > completedCoursesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* completedCoursesGetWatch() {
  yield takeLatest(COMPLETED_COURSES_GET._REQUEST, completedCoursesGet);
}

export default [
  dashboardInfoGetWatch(),
  emptyCoursesGetWatch(),
  lastCoursesGetWatch(),
  completedCoursesGetWatch(),
];
